import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  noteBookmarkList: { resultTotal: -1, noteBookmarkList: [] }, // Default value
  noteBookmarkListBookChapterVerse: { book: 0, chapter: 0, verse: 0 },
  pageNumberNote: 0,
  pageNumberNoteSearch: 0,
  caller4NoteBookmarkList: '',
};

const noteBookmarkListSlice = createSlice({
  name: 'noteBookmarkList',
  initialState,
  reducers: {
    setNoteBookmarkList: (state, action) => { state.noteBookmarkList = action.payload },
    setNoteBookmarkListBookChapterVerse: (state, action) => { state.noteBookmarkListBookChapterVerse = action.payload },
    setPageNumberNote: (state, action) => { state.pageNumberNote = action.payload },
    setPageNumberNoteSearch: (state, action) => { state.pageNumberNoteSearch = action.payload },
    setCaller4NoteBookmarkList: (state, action) => { state.caller4NoteBookmarkList = action.payload },
    reset4NoteBookmarkList: () => initialState,
  },
});

export const { setCaller4NoteBookmarkList, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setPageNumberNote, setPageNumberNoteSearch, reset4NoteBookmarkList } = noteBookmarkListSlice.actions;
export default noteBookmarkListSlice.reducer;